// ! WILL REMOVE
<template>
    <button>
        <slot />
    </button>
</template>

<script>
export default {};
</script>

<style lang="scss" scoped>
button {
    width: 198px;
    height: 43px;
    background: #7a70dfff;
    color: #ffffff;
    border-radius: 11px;
    border: none;
    font-family: Gilroy;
    font-style: normal;
    font-weight: 600;
    font-size: 15px;
    line-height: 17px;
    text-align: center;
    text-transform: uppercase;
    cursor: pointer;
    transition: 0.25s;
    &:hover {
        background: none;
        color: #7a70dfff;
        transition: 0.25s;
        border: 1px solid;
        border-color: #7a70dfff;
    }
}
</style>
